import React from "react"
import PropTypes from "prop-types"
import { FaCircle } from "react-icons/fa"

const SampleYear = (props) => {
  return (
    <div
      style={{ width: `${props.width}%` }}
      className={`progress-year ${props.active ? 'progress-year--active' : null}`}
      onClick={() => props.scrubTo(props.year)}
    >
      {props.active && <div className="progress-year--active__indicator"><FaCircle width='100%' height='100%' /></div>}
      <div className="progress-year__year">{props.year}</div>
    </div>
  )
}

SampleYear.propTypes = {
  width: PropTypes.number,
  year: PropTypes.string,
}

export default SampleYear
